import { BaseService } from './base.service';
import type { SendOtpDto, VerifyOtpDto, OtpResponse } from '../types/otp';


class OtpService extends BaseService {
  constructor() {
    super('/otp');
  }

  async sendOtp(data: SendOtpDto): Promise<OtpResponse> {
    return this.post<OtpResponse>('/register', data);
  }

  async sendLoginOtp(data: SendOtpDto): Promise<OtpResponse> {
    return this.post<OtpResponse>('/login', data);
  }

  async verifyOtp(data: VerifyOtpDto): Promise<OtpResponse> {
    // POST /api/otp/verify
    return this.post<OtpResponse>('/verify', data);
  }
}

export const otpService = new OtpService();
